module.exports = __webpack_public_path__ + "img/Shield.5c3aeca9.svg";